var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRiBuilding2Fill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 22.958H16.9167V7.24967L24.6428 10.5605C24.8603 10.6537 25.0456 10.8088 25.1758 11.0064C25.3059 11.204 25.3752 11.4355 25.375 11.6722V22.958H27.7917V25.3747H1.20834V22.958H3.62501V6.82676C3.62498 6.59297 3.69277 6.36418 3.82017 6.16815C3.94757 5.97212 4.1291 5.81726 4.34276 5.72234L13.6505 1.58622C13.7424 1.54539 13.8431 1.52815 13.9433 1.53605C14.0436 1.54395 14.1403 1.57675 14.2246 1.63147C14.309 1.6862 14.3784 1.76111 14.4264 1.84942C14.4745 1.93774 14.4998 2.03666 14.5 2.13722V22.958Z",
    fill: "#4772F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiBuilding2Fill);
export default __webpack_public_path__ + "static/media/ri_building-2-fill.d9b13dc37cbdf8b6d10aca352d43eadc.svg";
export { ForwardRef as ReactComponent };